<div id="top"></div>
<app-publicnavbar></app-publicnavbar>
<br>

<div style="background-color:#f5f5f5;width:99%;" class="mx-auto d-block" #details tabindex="-1">
  
  <table  role="presentation" width="80%" style="margin: 0px auto;">
    <tr>
      <td>
        <h3 class="display-6"  style="color: #7d3f98;">API Library</h3>
        <hr> 
        <h4 class="display-6"  style="color: #7d3f98;font-size: 20px;">
          {{displayApiLibHead}}
        </h4>
      </td>
    </tr>
  </table>


  
  <table class="table table-hover table-bordered center" style="width: 100%; word-break: break-word;background: white;" >
    <thead>
      <tr>
        <th scope="col" style="width:5%;background: #7d3f98;color: white;">#</th>
        <th scope="col" style="width:27%;background: #7d3f98;color: white;">API</th>
        <th scope="col" style="width:20%;background: #7d3f98;color: white;">Current Version Supported</th>
        <th scope="col" style="width:40%;background: #7d3f98;color: white;">Description</th>
        <th scope="col" style="width:8%;background: #7d3f98;color: white;">More Details</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of newArray; let i=index;" class="aetna-p">
        <td>{{i+1}}</td> 
        <!-- <td>{{data.id}}</td> -->
        <td>
             <div  [innerHTML]="data.API"></div>
            
          
             <label *ngIf="data.Environment=='Production'" class="badge badge-pill badge-primary" style=" text-transform: lowercase;">{{data.Environment}}</label>
             <label *ngIf="data.Environment=='sandbox'" class="badge badge-pill badge-secondary" style=" text-transform: lowercase;">{{data.Environment}}</label>
          
        </td>
        <td>{{data.Version}}</td>
        <td>{{data.Description}}</td>
        <td>
            <button pButton  icon="pi pi-external-link" class="aetna-button ui-button-raised ui-button-rounded" (click)="movetoStaticSwagger(data.SwagerFile)"> </button>
        </td>
      </tr>
      </tbody>
  </table>
  

<br>
</div>